import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { NgIcon } from '@ng-icons/core';
import {
    QpxButton,
    QpxHeroIcon,
    QpxIcon,
    type QpxHeroIconContext,
} from '@quipex/shared/ui';

interface CheckoutActionSummary {
    icon: string;
    context: QpxHeroIconContext;
    header: string;
    subtitle: string;
}

const CHECKOUT_ACTION_SUMMARIES: readonly CheckoutActionSummary[] = [
    {
        icon: 'lucideZap',
        context: 'caution',
        header: 'Instant activation',
        subtitle: 'Access in seconds',
    },
    {
        icon: 'lucideShieldCheck',
        context: 'success',
        header: 'Secure checkout',
        subtitle: 'Powered by Stripe',
    },
    {
        icon: 'lucideTag',
        context: 'info',
        header: 'Transparent pricing',
        subtitle: 'No hidden fees',
    },
];

@Component({
    selector: 'qpx-publish-checkout-actions',
    imports: [
        MatButtonModule,
        MatDialogModule,
        NgIcon,
        QpxButton,
        QpxHeroIcon,
        QpxIcon,
    ],
    templateUrl: './checkout-actions.html',
    styleUrl: './checkout-actions.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'block shrink-0' },
})
export class PublishCheckoutActions {
    public readonly canContinue = input.required<boolean>();
    public readonly checkoutLabel = input.required<string>();
    public readonly continueToCheckout = output<void>();

    protected readonly summaries = CHECKOUT_ACTION_SUMMARIES;
}
